var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var paymentProcessingDeviceCollection = require('./paymentProcessingDeviceCollection');

/**
 * Data Behavior hooked up to the payment device cache.
 * @class PaymentDeviceDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: paymentProcessingDeviceCollection
});
